import classNames from 'classnames';
import style from 'modules/footer/components/Footer/Сontacts/style.module.scss';
import {MAIN_CONTACTS_CHEERS} from 'modules/footer/components/Footer/constants';
import {Typography} from 'components/Typography';

const CheersBlock = () => {
    return (
        <div className={classNames(style.item, MAIN_CONTACTS_CHEERS.itemClass)}>
            <span className={style.title}>{MAIN_CONTACTS_CHEERS.title}</span>
            <a
                data-autotest-target={MAIN_CONTACTS_CHEERS.dataAutotestTarget}
                data-autotest-target-id={MAIN_CONTACTS_CHEERS.dataAutotestTargetId}
                href={MAIN_CONTACTS_CHEERS.href}
            >
                <Typography className={style.text} variant={'h5'}>
                    {MAIN_CONTACTS_CHEERS.text}
                </Typography>
            </a>
        </div>
    );
};

export default CheersBlock;
